import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx/lite';

type InlineBannerProps = {
  title: string;
  description: string | React.ReactNode;
  type?: 'warning' | 'info';
};

export const InlineBanner: React.FC<InlineBannerProps> = ({ title, description, type = 'warning' }) => {
  return (
    <div
      className={clsx(
        'flex w-full flex-col justify-start gap-2 rounded-lg p-5',
        type === 'warning' ? 'bg-orange-50 text-orange-800' : 'bg-primary-light-active text-primary-active',
      )}
    >
      <div className="flex items-center gap-2">
        <ExclamationCircleIcon className="size-6 flex-shrink-0" />
        <p className="text-lg font-semibold">{title}</p>
      </div>
      <p className="text-sm font-normal text-neutral-darker">{description}</p>
    </div>
  );
};
